import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col, Table } from 'reactstrap';
import { IAdHocRoundBoxScoreDto, IMatchFinalBoxScoreDto } from '../../../../../WorldDoomLeague';
import { MatchRoundAccuracyStatsCategories, AccuracyWeaponCategories, FormatMinMaxAvg, pcntgformat } from '../../../../../helpers'
import { useEffect, useState } from 'react';

interface MatchOverallWeaponsAccuracyTableProps {
    categoryObject: MatchRoundAccuracyStatsCategories;
    activeWeapon: string;
    finalBoxScore: IMatchFinalBoxScoreDto;
};

const MatchOverallWeaponsAccuracyTable = (props: MatchOverallWeaponsAccuracyTableProps) => {
    const [redPlayers, setRedPlayers] = useState<number[]>([]);
    const [bluePlayers, setBluePlayers] = useState<number[]>([]);

    const getRedTeamPlayers = (boxscore: IMatchFinalBoxScoreDto) => {
        var redPlayers = [] as number[];
        boxscore.redTeamPlayerFinalBoxScore.map((s, idx) => {
            redPlayers.push(s.playerId);
        });

        return redPlayers;
    };

    const getBlueTeamPlayers = (boxscore: IMatchFinalBoxScoreDto) => {
        var bluePlayers = [] as number[];
        boxscore.blueTeamPlayerFinalBoxScore.map((s, idx) => {
            bluePlayers.push(s.playerId);
        });

        return bluePlayers;
    };

    const createRedPlayerTableRow = () => {
        var redRows = [];
        var redRow = [];
        redPlayers.map((s, idx) => {
            redRow.push(<th scope="row">{props.finalBoxScore.redTeamPlayerFinalBoxScore.find(f => f.playerId === s).playerName}</th>);

            var playerRoundStats = props.finalBoxScore.redTeamPlayerFinalBoxScore.find(f => f.playerId === s);
            if (playerRoundStats) {
                if (props.categoryObject.category === AccuracyWeaponCategories.Accuracy) {
                    var playerAccuracyByWeapon = playerRoundStats.accuracyStats.accuracyByWeapon.find(f => f.weapon === props.activeWeapon);
                    if (playerAccuracyByWeapon) {
                        var playerAccuracy = playerAccuracyByWeapon.accuracy;
                        if (playerAccuracy) {
                            var hitMiss = playerAccuracy.hitMissRatio;
                            var spritePrcnt = playerAccuracy.spritePercent;
                            var pinpointPrcnt = playerAccuracy.pinpointPercent;
                            var pelletsHit = playerAccuracy.totalPelletsHit;
                            var pelletsMissed = playerAccuracy.totalPelletsMissed;
                            var pelletsAttempted = playerAccuracy.totalPelletsAttempted;
                            var shotsHit = playerAccuracy.totalShotsHit;
                            var shotsMissed = playerAccuracy.totalShotsMissed;
                            var shotsAttempted = playerAccuracy.totalShotsAttempted;

                            redRow.push(<td>{pcntgformat(hitMiss)}</td>);
                            redRow.push(<td>{FormatMinMaxAvg(spritePrcnt)} / {FormatMinMaxAvg(pinpointPrcnt)}</td>);
                            redRow.push(<td>{shotsHit} / {shotsMissed} / {shotsAttempted}</td>);
                            redRow.push(<td>{pelletsHit} / {pelletsMissed} / {pelletsAttempted}</td>);
                        } else {
                            redRow.push(<td>-</td>);
                            redRow.push(<td>- / -</td>);
                            redRow.push(<td>- / - / -</td>);
                            redRow.push(<td>-</td>);
                        }
                    } else {
                        redRow.push(<td>-</td>);
                        redRow.push(<td>- / -</td>);
                        redRow.push(<td>- / - / -</td>);
                        redRow.push(<td>-</td>);
                    }
                } else if (props.categoryObject.category === AccuracyWeaponCategories.AccuracyWithFlag) {
                    var playerAccuracyByWeapon = playerRoundStats.accuracyStats.accuracyByWeaponWithFlag.find(f => f.weapon === props.activeWeapon);
                    if (playerAccuracyByWeapon) {
                        var playerAccuracy = playerAccuracyByWeapon.accuracy;
                        if (playerAccuracy) {
                            var hitMiss = playerAccuracy.hitMissRatio;
                            var spritePrcnt = playerAccuracy.spritePercent;
                            var pinpointPrcnt = playerAccuracy.pinpointPercent;
                            var pelletsHit = playerAccuracy.totalPelletsHit;
                            var pelletsMissed = playerAccuracy.totalPelletsMissed;
                            var pelletsAttempted = playerAccuracy.totalPelletsAttempted;
                            var shotsHit = playerAccuracy.totalShotsHit;
                            var shotsMissed = playerAccuracy.totalShotsMissed;
                            var shotsAttempted = playerAccuracy.totalShotsAttempted;

                            redRow.push(<td>{pcntgformat(hitMiss)}</td>);
                            redRow.push(<td>{FormatMinMaxAvg(spritePrcnt)} / {FormatMinMaxAvg(pinpointPrcnt)}</td>);
                            redRow.push(<td>{shotsHit} / {shotsMissed} / {shotsAttempted}</td>);
                            redRow.push(<td>{pelletsHit} / {pelletsMissed} / {pelletsAttempted}</td>);
                        } else {
                            redRow.push(<td>-</td>);
                            redRow.push(<td>- / -</td>);
                            redRow.push(<td>- / - / -</td>);
                            redRow.push(<td>-</td>);
                        }
                    } else {
                        redRow.push(<td>-</td>);
                        redRow.push(<td>- / -</td>);
                        redRow.push(<td>- / - / -</td>);
                        redRow.push(<td>-</td>);
                    }
                }
            }

            redRows.push(<tr className='bg-danger'>{redRow}</tr>);
            redRow = [];
        });

        return (redRows);
    };

    const createBluePlayerTableRow = () => {
        var blueRows = [];
        var blueRow = [];
        bluePlayers.map((s, idx) => {
            blueRow.push(<th scope="row">{props.finalBoxScore.blueTeamPlayerFinalBoxScore.find(f => f.playerId === s).playerName}</th>);

            var playerRoundStats = props.finalBoxScore.blueTeamPlayerFinalBoxScore.find(f => f.playerId === s);
            if (playerRoundStats) {
                if (props.categoryObject.category === AccuracyWeaponCategories.Accuracy) {
                    var playerAccuracyByWeapon = playerRoundStats.accuracyStats.accuracyByWeapon.find(f => f.weapon === props.activeWeapon);
                    if (playerAccuracyByWeapon) {
                        var playerAccuracy = playerAccuracyByWeapon.accuracy;
                        if (playerAccuracy) {
                            var hitMiss = playerAccuracy.hitMissRatio;
                            var spritePrcnt = playerAccuracy.spritePercent;
                            var pinpointPrcnt = playerAccuracy.pinpointPercent;
                            var pelletsHit = playerAccuracy.totalPelletsHit;
                            var pelletsMissed = playerAccuracy.totalPelletsMissed;
                            var pelletsAttempted = playerAccuracy.totalPelletsAttempted;
                            var shotsHit = playerAccuracy.totalShotsHit;
                            var shotsMissed = playerAccuracy.totalShotsMissed;
                            var shotsAttempted = playerAccuracy.totalShotsAttempted;

                            blueRow.push(<td>{pcntgformat(hitMiss)}</td>);
                            blueRow.push(<td>{FormatMinMaxAvg(spritePrcnt)} / {FormatMinMaxAvg(pinpointPrcnt)}</td>);
                            blueRow.push(<td>{shotsHit} / {shotsMissed} / {shotsAttempted}</td>);
                            blueRow.push(<td>{pelletsHit} / {pelletsMissed} / {pelletsAttempted}</td>);
                        } else {
                            blueRow.push(<td>-</td>);
                            blueRow.push(<td>- / -</td>);
                            blueRow.push(<td>- / - / -</td>);
                            blueRow.push(<td>-</td>);
                        }
                    } else {
                        blueRow.push(<td>-</td>);
                        blueRow.push(<td>- / -</td>);
                        blueRow.push(<td>- / - / -</td>);
                        blueRow.push(<td>-</td>);
                    }
                } else if (props.categoryObject.category === AccuracyWeaponCategories.AccuracyWithFlag) {
                    var playerAccuracyByWeapon = playerRoundStats.accuracyStats.accuracyByWeaponWithFlag.find(f => f.weapon === props.activeWeapon);
                    if (playerAccuracyByWeapon) {
                        var playerAccuracy = playerAccuracyByWeapon.accuracy;
                        if (playerAccuracy) {
                            var hitMiss = playerAccuracy.hitMissRatio;
                            var spritePrcnt = playerAccuracy.spritePercent;
                            var pinpointPrcnt = playerAccuracy.pinpointPercent;
                            var pelletsHit = playerAccuracy.totalPelletsHit;
                            var pelletsMissed = playerAccuracy.totalPelletsMissed;
                            var pelletsAttempted = playerAccuracy.totalPelletsAttempted;
                            var shotsHit = playerAccuracy.totalShotsHit;
                            var shotsMissed = playerAccuracy.totalShotsMissed;
                            var shotsAttempted = playerAccuracy.totalShotsAttempted;

                            blueRow.push(<td>{pcntgformat(hitMiss)}</td>);
                            blueRow.push(<td>{FormatMinMaxAvg(spritePrcnt)} / {FormatMinMaxAvg(pinpointPrcnt)}</td>);
                            blueRow.push(<td>{shotsHit} / {shotsMissed} / {shotsAttempted}</td>);
                            blueRow.push(<td>{pelletsHit} / {pelletsMissed} / {pelletsAttempted}</td>);
                        } else {
                            blueRow.push(<td>-</td>);
                            blueRow.push(<td>- / -</td>);
                            blueRow.push(<td>- / - / -</td>);
                            blueRow.push(<td>-</td>);
                        }
                    } else {
                        blueRow.push(<td>-</td>);
                        blueRow.push(<td>- / -</td>);
                        blueRow.push(<td>- / - / -</td>);
                        blueRow.push(<td>-</td>);
                    }
                }
            }

            blueRows.push(<tr className='bg-primary'>{blueRow}</tr>);
            blueRow = [];
        });

        return (blueRows);
    };

    useEffect(() => {
        setRedPlayers(getRedTeamPlayers(props.finalBoxScore));
        setBluePlayers(getBlueTeamPlayers(props.finalBoxScore));

    }, [props.categoryObject, props.activeWeapon]);

    return (
        <React.Fragment>
            {bluePlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    <th>Hit/Miss %</th>
                                    <th>Sprite % / Pinpoint %</th>
                                    <th>Shot Hit / Missed / Attempted</th>
                                    <th>Pellets Hit / Missed / Attempted</th>
                                </tr>
                            </thead>
                            <tbody>
                                {createBluePlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}
            {redPlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    <th>Hit/Miss %</th>
                                    <th>Sprite % / Pinpoint %</th>
                                    <th>Shot Hit / Missed / Attempted</th>
                                    <th>Pellets Hit / Missed / Attempted</th>
                                </tr>
                            </thead>
                            <tbody>
                                {createRedPlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
};

export default MatchOverallWeaponsAccuracyTable;